import type { UtmParams } from '../../types/metaAdDraft';

// C8 UTM assembly (preview-only). The data model is the A1 STRUCTURED UtmParams
// (utm_source / medium / campaign / content / term), not a single free template
// string — so we build the query from the populated fields. Values are NOT
// URL-encoded here: AMs may type Meta dynamic placeholders like {{campaign.id}}
// which must reach Meta literally, and this string is an illustrative preview,
// not the published URL (Phase D assembles the real one).

const UTM_FIELDS: [keyof UtmParams, string][] = [
  ['source', 'utm_source'],
  ['medium', 'utm_medium'],
  ['campaign', 'utm_campaign'],
  ['content', 'utm_content'],
  ['term', 'utm_term'],
];

export function buildUtmQuery(utm: UtmParams): string {
  return UTM_FIELDS.filter(([k]) => (utm[k] ?? '').trim() !== '')
    .map(([k, param]) => `${param}=${utm[k]}`)
    .join('&');
}

// Append the assembled UTM query to a base URL. Returns null when there's no base
// URL or no UTM params (nothing to preview).
export function assembleUtmUrl(baseUrl: string, utm: UtmParams): string | null {
  const query = buildUtmQuery(utm);
  if (baseUrl.trim() === '' || query === '') return null;
  const sep = baseUrl.includes('?') ? '&' : '?';
  return `${baseUrl}${sep}${query}`;
}
